import { Component, OnInit, ViewChild } from '@angular/core';
import { Voo } from './model/voo';
import { VooRequisicao } from './model/vooRequisicao';
import { Protocolo } from './model/protocolo';
import { ProtocoloChamado } from '../app-enum/protocolo-chamado';
import { ExcelService } from '../../app-conciliation/service/excel.service';
import { ModalChamadoComponent } from '../app-dialog-ticket/app-dialog-ticket.component';
import { Router, ActivatedRoute } from '@angular/router';
import { properties } from '../../../environments/properties';
import { MatSort, Sort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { AppDataStampListService } from './app-data-stamp-list.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-data-stamp-list',
    templateUrl: './app-data-stamp-list.component.html',
    styleUrls: ['./app-data-stamp-list.component.css'],
    standalone: false
})
export class AppDataStampListComponent implements OnInit {

  public voo: VooRequisicao;
  public isLoadingResults: boolean;
  public paginaAtual = 1;
  public displayedColumnsStamLis: string[] = [
    'empiata',
    'dtVoo',
    'numVoo',
    'aeroporto',
    'descError',
    'namePax',
    'descSsr',
    'nameSis',
  ];

  public dataSourceImutavel = new MatTableDataSource<Voo>();

  public mensagemResposta: string;
  modalStatus = false;
  private eventsSubscription: any;
  public dataAtualStam: Date = new Date();
  public filterValueStam = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public sortedData: Voo[];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public listarDadosVooService: AppDataStampListService,
    private excelService: ExcelService,
    public dialog: MatDialog,
    private datePipe: DatePipe
  ) {
    this.voo = new VooRequisicao();
  }

  ngOnInit() {
    this.eventsSubscription = this.route.params.subscribe(params => {
      this.voo.dtInicio = params['date'];
      this.obterLista();
    });
  }

  applyFilter(filterValue: string) {
    this.filterValueStam = filterValue.trim().toLowerCase();
    this.dataSourceImutavel.filter = filterValue.trim().toLowerCase();
  }

  private obterLista(): void {
    this.listarDadosVooService.getDadosVoo(this.voo).subscribe(
      dataSource => {
        this.sortedData = dataSource;
      },
      err => {
        const protocolo: Protocolo = err.error;
        this.validarStatusBuscaVoo(protocolo);
      },
      () => {
        this.sortedData.sort(function(a, b) {
          return a.aeroporto < b.aeroporto
            ? -1 : a.aeroporto > b.aeroporto ? 1 : 0;
        });

        this.dataSourceImutavel = new MatTableDataSource(this.sortedData);
        this.dataSourceImutavel.paginator = this.paginator;
      }
    );
  }

  validarStatusBuscaVoo(protocolo: Protocolo): void {
    switch (protocolo.status) {
      case ProtocoloChamado.REQUEST_INVALIDO:
        this.mensagemResposta =
          properties.MODAL_CHAMADO_MENSAGEM_REQUEST_INVALIDO;
        break;
      default:
        this.mensagemResposta = protocolo.descricao;
        break;
    }
  }


  exportAsXLSX(): void {
    this.excelService.exportAsExcelFileStamp(
      this.dataSourceImutavel.data,
      'LISTA_SELO_' +
        this.datePipe.transform(this.dataAtualStam, 'dd_MM_yyyy')
    );
  }

  private tratarDataFim(): void {
    let dt: string = this.voo.dtFim;
    let dtA: string[] = [];
    dtA = dt.split('T');
    this.voo.dtFim = dtA[0] + 'T23:59:59';
  }

  private getFormatDateToString(dtdStam: string): string {
    if (dtdStam === null || dtdStam === undefined) {
      return '';
    }
    let dtarr: string[];
    let formatDt: string;
    dtarr = dtdStam.split('-');
    formatDt = dtarr[2] + '-' + dtarr[1] + '-' + dtarr[0];
    return formatDt;
  }

  private getFormatDateToStringIso(dtdtStamp: string): string {
    if (dtdtStamp === null || dtdtStamp === undefined) {
      return '';
    }
    let dtarr: string[];
    let dtar: string[];
    let formatDt: string;
    dtarr = dtdtStamp.split('T');
    dtar = dtarr[0].split('-');
    formatDt = dtar[2] + '-' + dtar[1] + '-' + dtar[0];
    return formatDt;
  }

  private formatDateHour(dtstampLi: String): string {
    if (dtstampLi === null || dtstampLi === undefined) {
      return '';
    }
    let dtarr: string[];
    let dtarH: string[];
    dtarr = dtstampLi.split('T');
    // +' '+ dtarr[1];
    dtarH = dtstampLi.split('T');
    dtarr = dtarr[0].split('-');
    return dtarr[2] + '-' + dtarr[1] + '-' + dtarr[0]; //' ' + dtarH[1];
  }

}
